import React from "react";
import { getBehaviourColourForPosition } from "@signolteam/shared/colours";
import { useDCContext } from "@src/context";
import { useManagerContext } from "@src/context/managerContext";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { AppUtils, SignolUtils, StorageUtils } from "@src/utils";
import { BackButton, DropDown, Tabs } from "@src/components/atoms";
import DefinitionsTab from "./DefinitionTab";
import PerformanceTab from "./PerformanceTab";
import AnalysisTab from "./AnalysisTab";
import BeehiveTab from "./BeehiveTab";
import DataProcessingTab from "./DataProcessingTab";
import { BehaviourDropDownManager } from "../../../components/atoms/BehaviourDropDown";
import { IMPERSONATED_SESSION_COOKIE } from "@src/constants/constants";

export const BehavioursPage = () => {
  const { profile, selectedBehaviour } = useManagerContext();
  const dc = useDCContext();

  const shouldShowAnalysisTab =
    profile.customer.industry === "aviation" &&
    (!!profile.customer.quicksightDashboardId || AppUtils.isMockedApp);

  const behiveLayoutDCString = `layouts__${profile.customer.customerCode.toLowerCase()}__behaviour${selectedBehaviour.behaviourAcronym.toLowerCase()}`;
  const isImpersonating =
    Object.keys(StorageUtils.getObjectItem(IMPERSONATED_SESSION_COOKIE) || {})
      .length > 0;
  const shouldShowNewBehaviourTabs =
    dc.existsDynamicReplacements(behiveLayoutDCString) &&
    (AppUtils.isFeatureAvailableForCustomer(
      "BehiveDashboards",
      profile.customer.customerCode,
    ) || // customer is allowed to see
      isImpersonating || // or admin is checking in prod
      (!SignolUtils.isProd() && !SignolUtils.isDemo())); // or it's not prod/demo so we want to test it

  const tabs = shouldShowNewBehaviourTabs
    ? [
        {
          name: dc.getDynamicReplacement(
            "fuel_manager__behaviour__tabs__performance",
          ),
          colour: "primary",
          content: (
            <BeehiveTab
              selectedBehaviour={selectedBehaviour}
              behiveLayoutDCString={behiveLayoutDCString}
            />
          ),
        },
        {
          name: dc.getDynamicReplacement(
            "fuel_manager__behaviour__tabs__data_processing",
          ),
          colour: "primary",
          content: <DataProcessingTab />,
        },
      ].filter(Boolean)
    : [
        {
          name: dc.getDynamicReplacement(
            "fuel_manager__behaviour__tabs__performance",
          ),
          colour: "primary",
          content: <PerformanceTab />,
        },
        {
          name: dc.getDynamicReplacement(
            "fuel_manager__behaviour__tabs__definition",
          ),
          colour: "primary",
          content: <DefinitionsTab selectedBehaviour={selectedBehaviour} />,
        },
        shouldShowAnalysisTab
          ? {
              name: dc.getDynamicReplacement(
                "fuel_manager__behaviour__tabs__analysis",
              ),
              colour: "primary",
              content: <AnalysisTab />,
            }
          : undefined,
      ].filter(Boolean);

  return (
    <div className="h-full flex flex-col">
      {/* Behaviour name + select */}
      <div className="flex flex-col items-center justify-between my-12 relative">
        <div className="absolute left-9">
          <BackButton />
        </div>
        {selectedBehaviour && (
          <h1
            className={`mt-12 md:mt-0 mx-6 my-4 text-center
              text-${getBehaviourColourForPosition(selectedBehaviour.order).name}-500
            `}
          >
            {selectedBehaviour.behaviourName}
          </h1>
        )}
        <BehaviourDropDownManager />
      </div>

      <div className="grow">
        <Tabs tabs={tabs} selected={0} gap={true} allowOverflow />
      </div>
    </div>
  );
};
